import React from 'react'

// Self-contained glass toggle. (Previously relied on Bootstrap's
// .custom-switch CSS, which no longer ships — it rendered as a bare checkbox.)
export default (props) => {
  const on = !!props.value;
  const toggle = () => {
    if (props.viewOnly) return;
    props.onChangeText(props.prop, !on);
  };

  return (
    <div
      onClick={toggle}
      style={{
        display: 'flex', alignItems: 'center', gap: 9,
        margin: '8px 0',
        cursor: props.viewOnly ? 'default' : 'pointer',
        opacity: props.viewOnly ? 0.6 : 1,
        userSelect: 'none',
      }}
    >
      <span
        role="switch"
        aria-checked={on}
        style={{
          width: 36, height: 20, borderRadius: 999, flexShrink: 0,
          background: on ? 'linear-gradient(135deg, var(--primary, #0DA1B2), var(--primary-dark, #067886))' : 'rgba(15,31,46,0.18)',
          position: 'relative',
          transition: 'background .15s ease',
          boxShadow: on ? '0 2px 8px rgba(13,161,178,0.35)' : 'inset 0 1px 2px rgba(15,31,46,0.12)',
        }}
      >
        <span style={{
          position: 'absolute', top: 2, left: on ? 18 : 2,
          width: 16, height: 16, borderRadius: '50%',
          background: '#fff',
          boxShadow: '0 1px 3px rgba(15,31,46,0.25)',
          transition: 'left .15s ease',
        }}></span>
      </span>
      <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text, #0f1f2e)' }}>{props.header}</span>
    </div>);
}
